import { guid } from '@/mixins/guid';

const image = color => ({
  _id: guid.methods.guid(),
  altText: false,
  src: `${process.env.S3_ASSETS_URL}mock-images/default-images/product-feature/t-shirt-mock-${color}.svg`,
});

export default function productFeature() {
  return {
    _id: false,
    type: 'droplet.productFeature',
    btnText: 'Add to Cart',
    mediaQueries: [],
    product: null,
    firstUpload: false,
    images: [image('green'), image('blue'), image('purple'), image('red')],
    zoom: true,
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-feature/droplet.schema.js